/**
 * Creates an object with REQUEST, SUCCESS, FAILURE, and RESET action types
 * @param {string} base - Base action name
 * @returns {Object} Object with action type variants
 */
const createActionTypes = (base) => ({
  REQUEST: `patient/${base.toLowerCase()}-request`,
  SUCCESS: `patient/${base.toLowerCase()}-success`,
  FAILURE: `patient/${base.toLowerCase()}-failure`,
  RESET: `patient/${base.toLowerCase()}-reset`
});

/**
 * Action types for treatment records operations
 */
export const treatmentRecordsActions = {
  // Main CRUD operations
  FETCH_TREATMENT_RECORDS: createActionTypes('fetch-treatment-records'),
  FETCH_SINGLE_RECORD: createActionTypes('fetch-single-record'),
  CREATE_TREATMENT_RECORD: createActionTypes('create-treatment-record'),
  UPDATE_TREATMENT_RECORD: createActionTypes('update-treatment-record'),
  DELETE_TREATMENT_RECORD: createActionTypes('delete-treatment-record'),

  // Direct actions for selected record management
  SET_SELECTED_RECORD: 'patient/set-selected-record',
  CLEAR_SELECTED_RECORD: 'patient/clear-selected-record'
};

/**
 * Create an action to set the selected treatment record
 * @param {Object} record - The record to select
 * @returns {Object} Action object
 */
export const setSelectedRecord = (record) => ({
  type: treatmentRecordsActions.SET_SELECTED_RECORD,
  payload: record
});

/**
 * Create an action to clear the selected treatment record
 * @returns {Object} Action object
 */
export const clearSelectedRecord = () => ({
  type: treatmentRecordsActions.CLEAR_SELECTED_RECORD
});
